const sampleStore = {
    language: "german",
    darkmode: true,
    sounds: true,
}

export default sampleStore;
